import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { useSettings } from "@/context/SettingsContext";
import { NAV_CATEGORIES, CATEGORY_META } from "@/i18n/translations";
import { BRAND_SIGNATURE, CONTACT_EMAIL, SIGNATURE_PILLARS } from "@/lib/brand";

export default function Footer() {
  const { lang, t } = useLang();
  const { settings } = useSettings();
  const year = new Date().getFullYear();

  return (
    <footer className="mt-24 border-t border-tertiary bg-anthracite text-ivory">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 lg:grid-cols-4 lg:px-10">
        <div className="lg:col-span-2">
          <div className="mb-2 flex items-center gap-2.5">
            <img src="/logo-rsti-96.png" alt="RSTI" className="h-9 w-9 rounded" />
            <span className="font-serif text-2xl font-semibold">RSTI</span>
            <span className="text-[10px] uppercase tracking-[0.3em] text-champagne">Global</span>
          </div>
          <p className="mb-4 text-xs uppercase tracking-[0.2em] text-champagne/80" data-testid="footer-signature">{BRAND_SIGNATURE}</p>
          <ul className="mb-5 space-y-1 text-xs text-ivory/50" data-testid="footer-signature-pillars">
            {SIGNATURE_PILLARS.map((p) => (
              <li key={p.key}><span className="text-ivory/80">{p.key}</span> — {lang === "fr" ? p.fr : p.en}</li>
            ))}
          </ul>
          <p className="max-w-md text-sm leading-relaxed text-ivory/60">
            {settings.hero?.[`positioning_${lang}`] || "Une plateforme internationale ancrée en Afrique."}
          </p>
          <p className="mt-4 max-w-md text-xs leading-relaxed text-ivory/40">
            {settings.contact?.[`note_${lang}`]}
          </p>
        </div>
        <div>
          <h4 className="mb-4 text-xs uppercase tracking-[0.2em] text-champagne">
            {t("explore_categories")}
          </h4>
          <ul className="space-y-2 text-sm text-ivory/70">
            {NAV_CATEGORIES.map((c) => (
              <li key={c}>
                <Link to={`/category/${c}`} className="transition-colors duration-300 hover:text-champagne">
                  {CATEGORY_META[c][lang]}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="mb-4 text-xs uppercase tracking-[0.2em] text-champagne">RSTI</h4>
          <ul className="space-y-2 text-sm text-ivory/70">
            <li><Link to="/connect" className="hover:text-champagne">{t("nav_connect")}</Link></li>
            <li><Link to="/insights" className="hover:text-champagne">{t("nav_insights")}</Link></li>
            <li><Link to="/about" className="hover:text-champagne">{t("nav_about")}</Link></li>
            <li>
              <a href="mailto:rstiglobal@gmail.com" className="hover:text-champagne" data-testid="footer-contact-email-gmail">rstiglobal@gmail.com</a>
            </li>
            <li>
              <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-champagne" data-testid="footer-contact-email">{CONTACT_EMAIL}</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-ivory/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-6 py-6 text-xs text-ivory/40 sm:flex-row lg:px-10">
          <span>© {year} RSTI Global. {t("footer_rights")}</span>
          <span className="uppercase tracking-[0.2em] text-champagne/70">{t("footer_tagline")}</span>
        </div>
      </div>
    </footer>
  );
}
